import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12h2a2 2 0 1 0 0 -4h-2v8","key":"svg-0"}],["path",{"d":"M10 16v-6m2 -2a2 2 0 0 1 2 2m0 4v2","key":"svg-1"}],["path",{"d":"M10 13h3","key":"svg-2"}],["path",{"d":"M17 8h4","key":"svg-3"}],["path",{"d":"M19 8v7","key":"svg-4"}],["path",{"d":"M3 3l18 18","key":"svg-5"}]]

const IconHttpPatchOff = createReactComponent('outline', 'http-patch-off', 'HttpPatchOff', __iconNode);

export default IconHttpPatchOff;